import { Lightbulb02Icon } from '@langchain/untitled-ui-icons';

import { useParams, useSearchParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';
import { useDataset, useOrganizationId, useSession } from '../../hooks/useSwr';
import DatasetIcon from '../../icons/DatasetIcon';
import ProjectIcon from '../../icons/ProjectIcon';
import { appDatasetsPath, appOrganizationPath } from '../../utils/constants';
import { useSessionClusterJob } from '../ClusterJob/hooks/useSessionClusterJobs';

export function SessionCrumb(props: Partial<BreadcrumbData>) {
  const { sessionId, annotationQueueId, conversationId, evaluatorId } =
    useParams();
  const [searchParams] = useSearchParams();
  const organizationId = useOrganizationId();

  const { data: session } = useSession(sessionId!);
  const hasReferenceDataset = !!session?.reference_dataset_id;
  const dataset = useDataset(session?.reference_dataset_id);

  const currentTab = searchParams.get('tab');
  const clusterJobId = searchParams.get('clusterJobId');
  const isInsightsTab = currentTab === '4';

  const { data: clusterJob } = useSessionClusterJob(
    sessionId || null,
    isInsightsTab && clusterJobId ? clusterJobId : null
  );

  let path = props.path;
  if (conversationId) {
    path += '?tab=1';
  } else if (evaluatorId) {
    path += `?tab=2`;
  } else if (isInsightsTab) {
    path += `?tab=4`;
    if (clusterJobId) {
      path += `&clusterJobId=${clusterJobId}`;
    }
  }

  return (
    <>
      {hasReferenceDataset && !annotationQueueId && (
        <Breadcrumb
          path={`/${appOrganizationPath}/${organizationId}/${appDatasetsPath}/${dataset.data?.id}`}
          icon={props.condensed ? undefined : <DatasetIcon />}
          name={dataset.data?.name ?? 'Dataset'}
        />
      )}
      <Breadcrumb
        icon={props.condensed ? undefined : <ProjectIcon />}
        name={session?.name ?? props.name ?? 'Session'}
        {...props}
        path={
          isInsightsTab && clusterJobId && path
            ? path.replace(`&clusterJobId=${clusterJobId}`, '')
            : path
        }
      />
      {isInsightsTab && (
        <Breadcrumb
          name="Insights Jobs"
          path={
            path && clusterJobId
              ? path.replace(`&clusterJobId=${clusterJobId}`, '')
              : path
          }
        />
      )}
      {isInsightsTab && clusterJobId && clusterJob && (
        <Breadcrumb
          name={clusterJob.name || `Job ${clusterJobId}`}
          icon={<Lightbulb02Icon className="mb-auto size-4" />}
          {...props}
          path={path}
        />
      )}
    </>
  );
}
